import { render, staticRenderFns } from "./level-edit.vue?vue&type=template&id=34472328&scoped=true&"
import script from "./level-edit.vue?vue&type=script&lang=js&"
export * from "./level-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34472328",
  null
  
)

export default component.exports